import React from 'react'
import { FaLinkedin } from "react-icons/fa";
import { BsGithub } from "react-icons/bs";
import { IoIosMail } from "react-icons/io";


function HeaderSocial() {
  return (
    <div className='header__socials'>
        <a href='https://www.linkedin.com/in/emre-durmus-62670223b/'
         target='_blank'> <FaLinkedin size={40}/> </a>
        <a href='https://github.com/emredurrmus'
         target='_blank'> <BsGithub size={40}/> </a>
        <a href='mailto:edurrmus@gmail.com'
         target='_blank'> <IoIosMail size={40}/> </a>
    </div>
  )
}

export default HeaderSocial